/**
 * ConditionItemWrapper Component
 *
 * Wrapper component for condition items with consistent styling.
 * Matches PartConditionContainer from ~/code/ui
 */

import { type ReactNode } from 'react';
import { Box } from '@customerio/pluma-components/react';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import * as styles from './index.css';

interface ConditionItemWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component for condition items with consistent styling.
 * Provides the styled container for individual conditions.
 */
export function ConditionItemWrapper({ children }: ConditionItemWrapperProps) {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap="100"
      p="100"
      w="full"
      className={styles.conditionItem}
      overflowWrap="anywhere"
      style={{
        backgroundColor: themeVars.color['surface-base-hover'],
        border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
        borderRadius: themeVars.radius['4'],
      }}
    >
      {children}
    </Box>
  );
}
